import { API_URL, fetchData } from "lib/api";
import { AttachedFileDto, AttachedFileSortColumn, AttachedFileWithPermissionsDto, AttachedFilesPostSingleRequest, UserDto } from "models";
import { AttachedFileDtoListRequest, AttachedFileUpdatePermissionsRequest, AttachedFilesCreateDirectoryPostRequest, AttachedFilesMoveFileRequest, AttachedFilesRenameFileRequest } from "models/files";
import { GenericSearchWrapperWithSortOrder } from "models";
import Cookies from 'js-cookie';

const AttachedFilesBasePath = `attachedfiles`;

export async function attachedFilesList(search: AttachedFileDtoListRequest): Promise<
  GenericSearchWrapperWithSortOrder<AttachedFileWithPermissionsDto, AttachedFileSortColumn>
> {
  const url = `${AttachedFilesBasePath}`;
  const queryParams = search;
  const response = await fetchData(url, queryParams);
  return response;
}

export const emptyGuid = "00000000-0000-0000-0000-000000000000";
export async function getFile(fileId: string): Promise<AttachedFileWithPermissionsDto> {
  const url = `${AttachedFilesBasePath}/${fileId ?? emptyGuid}`;
  const response = await fetchData(url, {});
  return response;
}

export async function getParents(fileId: string): Promise<
  AttachedFileDto[]
> {
  const url = `${AttachedFilesBasePath}/${fileId ?? emptyGuid}/parents`;
  const response = await fetchData(url, {});
  return response;
}

export async function createDirectory(model: AttachedFilesCreateDirectoryPostRequest): Promise<AttachedFileDto>
{
  const url = `${AttachedFilesBasePath}/createdirectory`;
  const response = await fetchData(url, undefined, {
    method: "POST",
    body: JSON.stringify(model),
  });
  return response;
}

export async function renameFile(model: AttachedFilesRenameFileRequest): Promise<void>
{
  const url = `${AttachedFilesBasePath}/${model.id}/rename`;
  const response = await fetchData(url, undefined, {
    method: "POST",
    body: JSON.stringify(model),
  });
  return response;
}

export async function moveFile(model: AttachedFilesMoveFileRequest): Promise<AttachedFileDto>
{
  const url = `${AttachedFilesBasePath}/${model.id}/move`;
  const response = await fetchData(url, undefined, {
    method: "POST",
    body: JSON.stringify(model),
  });
  return response;
}

export function attachedFilesGet(fileId: string, inline: boolean = false): string {
  const url = `${API_URL}${AttachedFilesBasePath}/${fileId}/download?inline=${inline ? "true" : "false"}`;
  return url;
}

export async function attachedFilesPost(request: AttachedFilesPostSingleRequest, files: File[]): Promise<AttachedFileDto> {
  let url = `${AttachedFilesBasePath}.json`;

  let query = {} as any;
  if (request.parentId) {
    query.parentId = request.parentId;
  }
  var data = new FormData();
  //data.append('parentId', request.parentId);

  for (let i = 0; i < files.length; i++) {
    data.append('files[]', files[i]);
  }

  const response = await fetchData(url, query, {
    method: 'POST',
    body: data,
    headers: {
      "X-XSRF-TOKEN": Cookies.get('XSRF-TOKEN'),
      "Accept": "application/json"
    }
  }, true, false);
  return response;
}

export async function fileDelete(model: AttachedFileDto): Promise<void>
{
  const url = `${AttachedFilesBasePath}/${model.id}`;
  const response = await fetchData(url, undefined, {
    method: "DELETE",
    body: JSON.stringify(model),
  });
  return response;
}

export async function fileUpdatePermission(model: AttachedFileUpdatePermissionsRequest): Promise<AttachedFileWithPermissionsDto>
{
  const url = `${AttachedFilesBasePath}/${model.id}/permissions`;
  const response = await fetchData(url, undefined, {
    method: "POST",
    body: JSON.stringify(model),
  });
  return response;
}
